// 자릿수 콤마 표시 (, -> .) / 소수점 표시(. -> ,)
export const formattingVNLanguage = (value: string) => {
  const parts = value.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return parts.join(',');
};
